// extracted by mini-css-extract-plugin
export default {"siteBeacon":"SiteBeacon_siteBeacon__C9ETt","darkBeacon":"SiteBeacon_darkBeacon__KiC4s","beaconTitle":"SiteBeacon_beaconTitle__MCPHx","beaconMotif":"SiteBeacon_beaconMotif__k5AA7"};